@if (isVariantC) {
  <app-verified-by-norse-variant-c
    [title]="appCopy.verifiedLogoText"
    (infoClick)="onInfoClick()"
  ></app-verified-by-norse-variant-c>
} @else {
  <div class="container search-widget-container">
    <div
      class="px-3 px-md-5 pt-4"
    >
      <div class="verified-card d-flex">
        <div class="d-flex flex-column justify-content-center">
          <div class="verified-logo ">
            <div class="text-nowrap">{{ appCopy.verifiedLogoText }} <span class="fa-regular fa-shield-check"></span></div>
            <div><img src="https://assets.flynorse.com/static/site/norse-name-white.svg" alt="Norse" /></div>
          </div>
        </div>
        <div class="verified-items">
          <div class="verified-item"
            [innerHTML]="
            appCopy.verifiedTitleOne | safeHtml: SanitizerValueType.HTML
          "></div>
          <div class="verified-item"
            [innerHTML]="
            appCopy.verifiedTitleTwo | safeHtml: SanitizerValueType.HTML
          "></div>
          <div class="verified-item"
            [innerHTML]="
            appCopy.verifiedTitleThree | safeHtml: SanitizerValueType.HTML
          "></div>
        </div>
        <div class="verified-info">
          <button
              appOnTap
              type="button"
              class="btn btn-link btn-white in-text lh-1"
              (click)="onInfoClick()"
              triggers="focus"
              placement="auto"
            >
              <i class="fa-regular fa-circle-info"></i>
            </button>
        </div>
      </div>
    </div>
</div>
}

